import { CmsPersonalDetailsPage } from '../../models/personal-details/cms-personal-details-page.interface';
import { mockCmsRegistrationRoot } from '../cms/cms-registration-root.mock';
import { mockCmsProtectionUpsellPanel } from '../protection-upsell/cms-protection-upsell-panel.mock';
import { mockCmsPersonalDetailsForm } from './cms-personal-details-form.mock';

export const mockCmsPersonalDetailsPage: CmsPersonalDetailsPage = {
  ...mockCmsRegistrationRoot,
  ...mockCmsPersonalDetailsForm,
  ...mockCmsProtectionUpsellPanel,
  pageTitle: 'Just a few more details',
  pageTitleCLP: 'Finish entering your details',
};
